import { render, staticRenderFns } from "./AnHealth.vue?vue&type=template&id=f79919e0&scoped=true&"
import script from "./AnHealth.vue?vue&type=script&lang=js&"
export * from "./AnHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79919e0",
  null
  
)

export default component.exports